import {createSelector} from 'reselect'

const refreshSelector = (state) => state.refresh; 

export const selectIsRefresh = createSelector(
    [refreshSelector],
    refresh => refresh.isRefresh
);